export const TAG_NAME_MAX_LENGTH = 40;
